import React, { useEffect, useState } from "react";
import {
  getSubcategories,
  createSubcategory,
  deleteSubcategory,
  updateSubcategory,
} from "../services/subcategoryService";
import { getCategories } from "../services/categoryService";

const SubcategoriesPage = () => {
  const [subcategories, setSubcategories] = useState([]);
  const [categories, setCategories] = useState([]);
  const [form, setForm] = useState({
    name: "",
    categoryId: "",
  });
  const [image, setImage] = useState(null);
  const [editingId, setEditingId] = useState(null);

  // 🧠 Завантаження підкатегорій і категорій
  useEffect(() => {
    (async () => {
      try {
        const [subsRes, catsRes] = await Promise.all([
          getSubcategories(),
          getCategories(),
        ]);
        setSubcategories(subsRes);
        setCategories(catsRes);
      } catch (err) {
        console.error("Помилка завантаження:", err);
      }
    })();
  }, []);

  // 🧱 Хендлери
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleImageChange = (e) => {
    setImage(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();
      formData.append("name", form.name);
      formData.append("categoryId", form.categoryId);
      if (image) formData.append("image", image);

      let newSub;
      if (editingId) {
        newSub = await updateSubcategory(editingId, formData);
        setSubcategories((prev) =>
          prev.map((s) => (s.id === editingId ? newSub : s))
        );
      } else {
        newSub = await createSubcategory(formData);
        setSubcategories((prev) => [newSub, ...prev]);
      }

      setForm({ name: "", categoryId: "" });
      setImage(null);
      setEditingId(null);
    } catch (err) {
      console.error("Помилка збереження:", err);
      alert("Не вдалося зберегти підкатегорію");
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Видалити підкатегорію?")) return;
    try {
      await deleteSubcategory(id);
      setSubcategories((prev) => prev.filter((s) => s.id !== id));
    } catch (err) {
      console.error("Помилка видалення:", err);
    }
  };

  const handleEdit = (sub) => {
    setEditingId(sub.id);
    setForm({
      name: sub.name,
      categoryId: sub.Category?.id || "",
    });
  };

  const cancelEdit = () => {
    setEditingId(null);
    setForm({ name: "", categoryId: "" });
    setImage(null);
  };

  return (
    <div className="p-6 bg-[#F5F0E6] min-h-screen">
      <h2 className="text-2xl font-bold mb-6 text-[#4B2E2B]">
        Підкатегорії
      </h2>

      {/* Форма */}
      <div className="bg-white p-6 rounded-lg shadow-md border border-[#D2B48C] mb-6">
        <h3 className="text-lg font-semibold mb-4 text-[#4B2E2B]">
          {editingId ? "Редагування підкатегорії" : "Створення підкатегорії"}
        </h3>

        <form
          onSubmit={handleSubmit}
          className="grid grid-cols-1 md:grid-cols-2 gap-4"
        >
          <input
            type="text"
            name="name"
            value={form.name}
            onChange={handleChange}
            placeholder="Назва підкатегорії"
            required
            className="border p-2 rounded"
          />

          <select
            name="categoryId"
            value={form.categoryId}
            onChange={handleChange}
            required
            className="border p-2 rounded"
          >
            <option value="">Виберіть категорію</option>
            {categories.map((c) => (
              <option key={c.id} value={c.id}>
                {c.name}
              </option>
            ))}
          </select>

          <div className="md:col-span-2">
            <input
              type="file"
              accept="image/*"
              onChange={handleImageChange}
              className="border p-2 rounded w-full"
            />
          </div>

          <div className="flex gap-4 mt-4 md:col-span-2">
            <button
              type="submit"
              className="bg-[#4B2E2B] text-white px-6 py-2 rounded hover:bg-[#3A2422]"
            >
              {editingId ? "Оновити" : "Створити"}
            </button>
            {editingId && (
              <button
                type="button"
                onClick={cancelEdit}
                className="border px-6 py-2 rounded hover:bg-gray-100"
              >
                Скасувати
              </button>
            )}
          </div>
        </form>
      </div>

      {/* Таблиця */}
      <div className="overflow-x-auto bg-white rounded-lg shadow-md border border-[#D2B48C]">
        <table className="w-full border-collapse">
          <thead className="bg-[#4B2E2B] text-white">
            <tr>
              <th className="p-3 text-left">Фото</th>
              <th className="p-3 text-left">Назва</th>
              <th className="p-3 text-left">Категорія</th>
              <th className="p-3 text-left w-[150px]">Дії</th>
            </tr>
          </thead>
          <tbody>
            {subcategories.length === 0 && (
              <tr>
                <td colSpan="4" className="text-center p-4 text-gray-500">
                  Немає підкатегорій
                </td>
              </tr>
            )}
            {subcategories.map((sub) => (
              <tr key={sub.id} className="border-b hover:bg-[#F5F0E6]">
                <td className="p-3">
                  {sub.image ? (
                    <img
                      src={`http://localhost:5000/uploads/${sub.image}`}
                      alt={sub.name}
                      className="h-16 w-16 object-cover rounded border"
                    />
                  ) : (
                    <div className="h-16 w-16 bg-gray-100 flex items-center justify-center text-gray-400 rounded">
                      No
                    </div>
                  )}
                </td>
                <td className="p-3 font-semibold text-[#4B2E2B]">
                  {sub.name}
                </td>
                <td className="p-3">{sub.Category ? sub.Category.name : "Немає категорії"}</td>
                <td className="p-3 flex gap-2">
                  <button
                    onClick={() => handleEdit(sub)}
                    className="bg-[#A47551] text-white px-3 py-1 rounded hover:bg-[#8B5E3C]"
                  >
                    Edit
                  </button>
                  <button
                    onClick={() => handleDelete(sub.id)}
                    className="bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600"
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default SubcategoriesPage;
